<template>
  <div>
    <!-- ============================임차인(LE) dashboard============================ 
    힘찬씨! Figma보면 임대인, 공인중개사 대쉬보드가 비슷하고, 임차인만 다릅니다.-->
    <div
      class="row jipvio-dashboard"
      style="margin-top: 70px;"
      v-if="sessionUserInfo.type == 'LE'"
    >
      <div class="col-md-11 col-sm-12 row m-auto">
        <div class="col-md-6 ml-auto mt-40">
          <h4 class="card-title jipvio-text-center mt-0">찜한 매물</h4>
          <div class="card card-chart mt-20">
            <!----><!----><!----><!---->
            <!-- <div class="card-header">
                  <h4 class="card-title jipvio-text-center">
                    전체 방문자 수 &amp; 클릭수
                  </h4>
                </div> -->
            <div class="card-body">
              <div class="chart-area Like_list">
                <ul
                  class="cl-bth d-flex justify-content-around align-items-center pl-0"
                >
                  <li><img src="/img/jipvio-bg1.jpg" /></li>
                  <li><img src="/img/jipvio-bg2.jpg" /></li>
                  <li><img src="/img/jipvio-bg3.jpg" /></li>
                </ul>
              </div>
            </div>
            <!---->
            <button type="button" class="el-button fr el-button--info">
              <!----><!----><span
                ><i
                  class="el-icon-more
"
                ></i>
                &nbsp;더보기</span
              >
            </button>
          </div>
        </div>
        <div class="col-md-6 mr-auto mt-40">
          <h4 class="card-title jipvio-text-center mt-0 mb-0">
            집비오 소식
          </h4>
          <div class="card card-timeline card-plain">
            <!----><!----><!----><!----><!---->
            <div class="card-body">
              <ul class="timeline timeline-simple">
                <li class="timeline-inverted">
                  <div class="timeline-badge danger">
                    <i class="now-ui-icons objects_planet"></i>
                  </div>
                  <div class="timeline-panel">
                    <div class="timeline-heading">
                      <span class="badge badge-danger">공지사항</span>
                    </div>
                    <div class="timeline-body">
                      <p>
                        집비오 가입자 수
                        <span style="font-weight: bold; font-size: 2em;"
                          >1만 명</span
                        >
                        돌파 이벤트!
                      </p>
                    </div>
                    <h6><span> 2020-03-01 </span></h6>
                  </div>
                </li>
                <li class="timeline-inverted">
                  <div class="timeline-badge success">
                    <i class="now-ui-icons shopping_tag-content"></i>
                  </div>
                  <div class="timeline-panel">
                    <div class="timeline-heading">
                      <span class="badge badge-success">새로운 소식</span>
                    </div>
                    <div class="timeline-body">
                      <p>
                        비대면으로 전속중개 계약을 체결할 수 있는 플랫폼
                        <span style="font-weight: bold; font-size: 1.5em;"
                          >집비오</span
                        >가 출시되었습니다.<br />
                        전속중개계약을 체결한 매물만 등록이 가능하기 때문에,
                        허위매물을 줄이고 건전한 부동산 중개문화를 정착시킬
                        것으로 기대합니다.
                      </p>
                    </div>
                    <!---->
                  </div>
                </li>
              </ul>
            </div>
            <!----><!---->
          </div>
        </div>
      </div>
      <div class="row col-md-11 col-sm-12 m-auto">
        <div class="col-md-6">
          <h4 class="card-title jipvio-text-center mt-0">
            추천 매물
          </h4>
          <div class="card card-chart mt-20">
            <div class="card-body">
              <div class="chart-area Best_list">
                <ul
                  class="cl-bth d-flex justify-content-around align-items-center pl-0"
                >
                  <li><img src="/img/jipvio-bg1.jpg" /></li>
                  <li><img src="/img/jipvio-bg2.jpg" /></li>
                  <li><img src="/img/jipvio-bg3.jpg" /></li>
                </ul>
              </div>
            </div>
            <!---->
            <button type="button" class="el-button fr el-button--info">
              <!----><!----><span
                ><i
                  class="el-icon-more
"
                ></i>
                &nbsp;더보기</span
              >
            </button>
          </div>
        </div>
        <div class="col-md-4 ml-auto PS_layout">
          <div class="card">
            <!----><!----><!----><!---->
            <div class="card-header">
              <div>
                <h4 class="card-title jipvio-text-center mb-0 mt-0">
                  문의 내역
                </h4>
              </div>
            </div>
            <div class="card-body table-full-width">
              <div
                class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"
              >
                <div class="hidden-columns">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div class="el-table__header-wrapper">
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    class="el-table__header"
                  >
                    <colgroup>
                      <col name="el-table_2_column_5" width="206" />
                      <col name="el-table_2_column_6" width="204" />
                      <col name="el-table_2_column_7" width="204" />
                      <col name="gutter" width="0" />
                    </colgroup>
                    <thead class="has-gutter">
                      <tr class="">
                        <th
                          colspan="1"
                          rowspan="1"
                          class="el-table_2_column_5     is-leaf"
                        >
                          <div class="cell">법정동</div>
                        </th>
                        <th
                          colspan="1"
                          rowspan="1"
                          class="el-table_2_column_6     is-leaf"
                        >
                          <div class="cell">건물명</div>
                        </th>
                        <th
                          colspan="1"
                          rowspan="1"
                          class="el-table_2_column_7     is-leaf"
                        >
                          <div class="cell">제목</div>
                        </th>
                        <th
                          class="gutter"
                          style="width: 0px; display: none;"
                        ></th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div class="el-table__body-wrapper is-scrolling-none">
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    class="el-table__body"
                  >
                    <colgroup>
                      <col name="el-table_2_column_5" width="206" />
                      <col name="el-table_2_column_6" width="204" />
                      <col name="el-table_2_column_7" width="204" />
                    </colgroup>
                    <tbody>
                      <tr class="el-table__row">
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_5  "
                        >
                          <div class="cell">개봉동</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_6  "
                        >
                          <div class="cell">A 아파트</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_7  "
                        >
                          <div class="cell">보증금 문의</div>
                        </td>
                      </tr>
                      <tr class="el-table__row">
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_5  "
                        >
                          <div class="cell">오류동</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_6  "
                        >
                          <div class="cell">B 빌라</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_7  "
                        >
                          <div class="cell">방문 문의</div>
                        </td>
                      </tr>
                      <tr class="el-table__row">
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_5  "
                        >
                          <div class="cell">고척동</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_6  "
                        >
                          <div class="cell">C 아파트</div>
                        </td>
                        <td
                          rowspan="1"
                          colspan="1"
                          class="el-table_2_column_7  "
                        >
                          <div class="cell">옵션 문의</div>
                        </td>
                      </tr>
                      <!---->
                    </tbody>
                  </table>
                  <!----><!---->
                </div>
                <!----><!----><!----><!---->
                <div
                  class="el-table__column-resize-proxy"
                  style="display: none;"
                ></div>
              </div>
              <button type="button" class="el-button fr el-button--info">
                <!----><!----><span
                  ><i
                    class="el-icon-more
"
                  ></i>
                  &nbsp;더보기</span
                >
              </button>
            </div>
            <!----><!---->
          </div>
        </div>
      </div>

      <card class="mt-50" card-body-classes="table-full-width" no-footer-line>
      </card>
    </div>

    <!-- ============================임대인(LO), 공인중개사(AG) dashboard============================ -->
    <div
      class="row jipvio-dashboard"
      style="margin-top: 70px"
      v-if="sessionUserInfo.type == 'LO' || sessionUserInfo.type == 'AG'"
    >
      <div class="col-md-10 col-sm-12 row m-auto">
        <div class="col-md-5 ml-auto mt-40">
          <h4 class="card-title jipvio-text-center mt-0">방문자 통계</h4>
          <card class="card-chart mt-20" no-footer-line>
            <template slot="header">
              <h4 class="card-title jipvio-text-center">
                전체 방문자 수 & 클릭수
              </h4>
            </template>
            <div class="chart-area">
              <bar-chart
                :labels="barChart2.labels"
                :datasets="barChart2.datasets"
                :height="200"
              >
              </bar-chart>
            </div>
            <div slot="footer" class="stats" style="width:100%">
              <div class="fl">
                <i class="now-ui-icons ui-2_time-alarm"></i> Last 7 days
              </div>
              <div class="fr pr-20">
                <div class="pr-30">
                  <i style="color: #f96332;" class="fas fa-square"></i>전체
                  방문자 수
                </div>
                <div>
                  <i style="color: #2CA8FF;" class="fas fa-square"></i>클릭수
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-md-7 mr-auto mt-40">
          <h4 class="card-title jipvio-text-center mt-0 mb-0">집비오 소식</h4>
          <time-line type="simple">
            <time-line-item
              inverted
              badge-icon="now-ui-icons objects_planet"
              badge-type="danger"
            >
              <span slot="header" class="badge badge-danger">공지사항</span>
              <p slot="content">
                집비오 가입자 수
                <span style="font-weight: bold; font-size: 2em">1만 명</span>
                돌파 이벤트!
              </p>
              <span slot="footer"> 2020-03-01 </span>
            </time-line-item>

            <time-line-item
              inverted
              badge-icon="now-ui-icons shopping_tag-content"
              badge-type="success"
            >
              <span slot="header" class="badge badge-success">새로운 소식</span>
              <p slot="content">
                비대면으로 전속중개 계약을 체결할 수 있는 플랫폼
                <span style="font-weight: bold; font-size: 1.5em;">집비오</span
                >가 출시되었습니다.<br />
                전속중개계약을 체결한 매물만 등록이 가능하기 때문에, 허위매물을
                줄이고 건전한 부동산 중개문화를 정착시킬 것으로 기대합니다.
              </p>
            </time-line-item>
          </time-line>
        </div>
      </div>
      <div class="row col-md-10 col-sm-12 m-auto">
        <div class="col-md-4 mb-50">
          <card card-body-classes="table-full-width">
            <div slot="header">
              <h4 class="card-title jipvio-text-center mb-0 mt-0">매물현황</h4>
            </div>
            <el-table :data="tableData">
              <el-table-column
                min-width="100"
                label="법정동"
                property="Dong"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="건물명"
                property="Name"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="조회수"
                property="Views"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="찜수"
                property="Likes"
              ></el-table-column>
            </el-table>
            <el-button type="info" class="fr" style=""
              ><i
                class="el-icon-more
"
              ></i>
              &nbsp;더보기</el-button
            >
          </card>
        </div>
        <div class="col-md-4  mb-50">
          <card card-body-classes="table-full-width">
            <div slot="header">
              <h4 class="card-title jipvio-text-center mb-0 mt-0">고객문의</h4>
            </div>
            <el-table :data="tableData2">
              <el-table-column
                min-width="100"
                label="법정동"
                property="Dong"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="건물명"
                property="Name"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="제목"
                property="Titles"
              ></el-table-column>
            </el-table>
            <el-button type="info" class="fr" style=""
              ><i
                class="el-icon-more
"
              ></i>
              &nbsp;더보기</el-button
            >
          </card>
        </div>
        <!--계약일정 UI는 공인중개사만 있으므로, v-if처리함.-->
        <div class="col-md-4  mb-50" v-if="sessionUserInfo.type == 'AG'">
          <card card-body-classes="table-full-width">
            <div slot="header">
              <h4 class="card-title jipvio-text-center mb-0 mt-0">계약일정</h4>
            </div>
            <el-table :data="tableData3">
              <el-table-column
                min-width="100"
                label="날짜"
                property="Dates"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="법정동"
                property="Dong"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="건물명"
                property="Name"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="종류"
                property="Kinds"
              ></el-table-column>
            </el-table>
            <el-button type="info" class="fr" style=""
              ><i class="el-icon-more"></i> &nbsp;더보기</el-button
            >
          </card>
        </div>
      </div>
    </div>

    <!-- ======================================admin Dash =======================-->
    <div
      class="row"
      style="margin-top: 70px"
      v-if="sessionUserInfo.type == 'AM'"
    >
      <dashboard-header style="width: 100%; margin-left: "></dashboard-header>
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon" style="color: #2ca8ff;">
                      <i class="jipvio-ui-icons-users"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="20"></animated-number>
                      <small>명</small>
                    </h3>
                    <h6 class="stats-title">신규 가입자수</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="el-icon-office-building"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="2"></animated-number>
                      <small>개</small>
                    </h3>
                    <h6 class="stats-title">신규 매물의뢰</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-info">
                      <i class="el-icon-chat-dot-round"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="10"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">신규 문의건수</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-danger">
                      <i class="fas fa-history"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="24"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">매물노출건수</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon" style="color: #2ca8ff;">
                      <i class="jipvio-ui-icons-users"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="30"></animated-number>
                      <small>명</small>
                    </h3>
                    <h6 class="stats-title">신규 가입자수</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="el-icon-chat-dot-round"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="10"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">신규 문의건수</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon" style="color: #2ca8ff;">
                      <i class="jipvio-ui-icons-users"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="24"></animated-number>
                      <small>명</small>
                    </h3>
                    <h6 class="stats-title">신규 가입자수</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="el-icon-office-building"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="20"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">신규 매물등록 요청</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-info">
                      <i class="el-icon-chat-dot-round"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="10"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">신규 문의건수</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-danger">
                      <i class="fas fa-history"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="20"></animated-number>
                      <small>건</small>
                    </h3>
                    <h6 class="stats-title">매물노출건수</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";

import { createNamespacedHelpers } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

// =====================================================공인중개사
import BarChart from "@/pages/Charts/BarChart.js";
import TimeLine from "@/components/Timeline/TimeLine.vue";
import TimeLineItem from "@/components/Timeline/TimeLineItem.vue";
import { Button, Table, TableColumn } from "element-ui";

// =====================================================admin
import AnimatedNumber from "@/components/AnimatedNumber.vue";
import DashboardHeader from "@/pages/Dashboard/DashboardHeader.vue";

export default {
  components: {
    card,
    BarChart,
    TimeLine,
    TimeLineItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    AnimatedNumber,
    DashboardHeader
  },

  data() {
    return {
      //공인중개사 data================================================================
      barChart2: {
        labels: [
          "1월",
          "2월",
          "3월",
          "4월",
          "5월",
          "6월",
          "7월",
          "8월",
          "9월",
          "10월",
          "11월",
          "12월"
        ],
        datasets: [
          {
            backgroundColor: "#f96332",
            data: [15, 20, 28, 30, 43, 50, 55, 58, 44, 52, 45, 58]
          },
          {
            backgroundColor: "#2CA8FF",
            data: [5, 10, 15, 10, 15, 10, 15, 10, 15, 20, 25, 30]
          }
        ]
      },
      tableData: [
        {
          id: 1,
          Dong: "개봉동",
          Name: "A 아파트",
          Views: "10",
          Likes: "10"
        },
        {
          id: 2,
          Dong: "오류동",
          Name: "B 빌라",
          Views: "15",
          Likes: "10"
        },
        {
          id: 3,
          Dong: "고척동",
          Name: "C 아파트",
          Views: "100",
          Likes: "50"
        }
      ],
      tableData2: [
        {
          id: 1,
          Dong: "개봉동",
          Name: "A 아파트",
          Titles: "보증금 문의"
        },
        {
          id: 2,
          Dong: "오류동",
          Name: "B 빌라",
          Titles: "방문 문의"
        },
        {
          id: 3,
          Dong: "고척동",
          Name: "C 아파트",
          Titles: "옵션 문의"
        }
      ],
      tableData3: [
        {
          id: 1,
          Dates: "20-10-23",
          Dong: "개봉동",
          Name: "A 아파트",
          Kinds: "잔금일"
        },
        {
          id: 2,
          Dates: "20-10-23",
          Dong: "오류동",
          Name: "B 빌라",
          Kinds: "잔금일"
        },
        {
          id: 3,
          Dates: "20-10-23",
          Dong: "고척동",
          Name: "C 아파트",
          Kinds: "게약일"
        }
      ]
    };
    //====================================================================
  },

  created() {},

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    })
  },

  methods: {
    // 공인중개사 methods============================================
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 0) {
        return "table-success";
      } else if (rowIndex === 2) {
        return "table-info";
      } else if (rowIndex === 4) {
        return "table-danger";
      } else if (rowIndex === 6) {
        return "table-warning";
      }
      return "";
    }
    //============================================================
  },
  mounted() {},
  watch: {}
};
</script>
<style>
/* 임대인 임차인 ========================================== */
.jipvio-dashboard .card-chart .chart-area.Like_list,
.jipvio-dashboard .card-chart .chart-area.Best_list {
  height: 300px;
}
.jipvio-dashboard .card-chart .chart-area.Like_list ul,
.jipvio-dashboard .card-chart .chart-area.Best_list ul {
  width: 100%;
  height: 100%;
}
.jipvio-dashboard .card-chart .chart-area.Like_list ul li,
.jipvio-dashboard .card-chart .chart-area.Best_list ul li {
  width: 200px;
  height: 200px;
  list-style: none;
}
.jipvio-dashboard .card-chart .chart-area.Like_list ul li img,
.jipvio-dashboard .card-chart .chart-area.Best_list ul li img {
  object-fit: cover;
  height: 100%;
}
.PS_layout {
  margin-top: 131px;
}

/* 공인중개사========================================== */
.table-transparent {
  background-color: transparent !important;
}

/*======================== admin=================== */
/* canvas#line-chart {
  width: 90% !important;
  margin: auto;
} */
</style>
